import { useState } from "react";
import { useApi } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { PageHeader, Reveal } from "@/components/site/Reveal";
import { ListingCard } from "@/components/site/ListingCard";
import { FilterPills } from "@/pages/HomesForSale";
import { useLang } from "@/lib/i18n";

const TIERS = [
  { id: "all", label: "" },
  { id: "$", label: "$ < 50" },
  { id: "$$", label: "$$ < 100" },
  { id: "$$$", label: "$$$ > 100" },
];

export default function ForRent() {
  const [tier, setTier] = useState("all");
  const { t } = useLang();
  const { data } = useApi("/listings?kind=rent", []);
  const items = tier === "all" ? data : data.filter((l) => l.price_tier === tier);
  return (
    <>
      <Seo title={t("rent.seoTitle")} description={t("rent.seoDesc")} />
      <PageHeader testId="rent-header" eyebrow={t("rent.eyebrow")} title={t("rent.title")}>
        {t("rent.intro")} <strong className="text-forest">$</strong> &lt; $50 · <strong className="text-forest">$$</strong> &lt; $100 · <strong className="text-forest">$$$</strong> &gt; $100.
      </PageHeader>
      <section className="container-x pb-28">
        <FilterPills prefix="rent" options={TIERS.map((x) => (x.id === "all" ? { ...x, label: t("filter.all") } : x))} value={tier} onChange={setTier} />
        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-testid="rent-grid">
          {items.map((l, i) => (
            <Reveal key={l.slug} delay={(i % 3) * 0.08}><ListingCard listing={l} /></Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
